var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoofing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(100,21,255,1)",
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.149 16.062h6.06l-.053 3.575-6.007 5.406v-8.981zM24.907 14.083l-23.907 21.086 2.52 2.831 21.485-18.954 21.481 18.954 2.514-2.831-23.903-21.086-.097-.083-.093.083z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofing);
export default __webpack_public_path__ + "static/media/roofing.0a429440538dfa856d78036264345e0a.svg";
export { ForwardRef as ReactComponent };